module.exports = __webpack_public_path__ + "img/gerch-project-ipad.5fc51d68.png";